module.exports = __webpack_public_path__ + "img/3.e1d6b8b9.jpg";